// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.warningModal {\n  min-height: 250px;\n  display: flex;\n  flex-direction: column;\n}\n.partyGapTable.v-data-table {\n  background: #fafafa;\n}\n", ""]);
// Exports
module.exports = exports;
